import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { submitFeedback } from '../api';
import './FeedbackButton.css';

type Category = 'bug' | 'idea' | 'other';

const CATEGORIES: { value: Category; emoji: string; label: string }[] = [
  { value: 'bug',   emoji: '🐛', label: 'Bug'       },
  { value: 'idea',  emoji: '💡', label: 'Idea'      },
  { value: 'other', emoji: '💬', label: 'Other'     },
];

export default function FeedbackButton() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState<Category>('other');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  function handleOpen() { setOpen(true); setDone(false); }
  function handleClose() { setOpen(false); setMessage(''); setCategory('other'); setDone(false); }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!message.trim() || submitting) return;
    setSubmitting(true);
    await submitFeedback(message.trim(), category, location.pathname);
    setSubmitting(false);
    setDone(true);
    setTimeout(handleClose, 2500);
  }

  return (
    <>
      {/* Floating trigger — bottom-left so it never blocks match cards or pick buttons */}
      <button className="fb-fab" onClick={handleOpen} aria-label="Give feedback">
        <span className="fb-fab-icon">💬</span>
        <span className="fb-fab-label">Feedback</span>
      </button>

      {open && (
        <div className="fb-overlay" onClick={handleClose}>
          <div className="fb-modal" onClick={e => e.stopPropagation()}>

            <div className="fb-header">
              <span className="fb-title">Share Feedback</span>
              <button className="fb-close" onClick={handleClose} aria-label="Close">✕</button>
            </div>

            {done ? (
              <div className="fb-success">
                <span className="fb-success-icon">🙌</span>
                <p className="fb-success-msg">Thanks! We read every message.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="fb-form">
                <div className="fb-categories">
                  {CATEGORIES.map(c => (
                    <button
                      key={c.value}
                      type="button"
                      className={`fb-cat${category === c.value ? ' fb-cat--active' : ''}`}
                      onClick={() => setCategory(c.value)}
                    >
                      {c.emoji} {c.label}
                    </button>
                  ))}
                </div>

                <textarea
                  className="fb-textarea"
                  placeholder={
                    category === 'bug'  ? 'What happened? What did you expect?' :
                    category === 'idea' ? 'What would make TopQik better?' :
                    'Tell us anything — we\'re listening.'
                  }
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  rows={4}
                  maxLength={1000}
                  required
                  autoFocus
                />
                <div className="fb-char-count">{message.length}/1000</div>

                <button className="fb-submit" type="submit" disabled={submitting || !message.trim()}>
                  {submitting ? 'Sending…' : 'Send Feedback'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
